class SwiftCountry {
  serialNumber: number;
  description: string;
  shortDescription: string;

  constructor(serialNumber: number, description: string, shortDescription: string) {
    this.serialNumber = serialNumber;
    this.description = description;
    this.shortDescription = shortDescription;
  }
}

export { SwiftCountry };
